import { Badge } from "@/components/ui/badge";
import { useMessage } from "@/hooks/use-message";
import { Component, ErrorInfo, ReactNode } from "react";

class ErrorBoundary extends Component<
  { children: ReactNode },
  { hasError: boolean }
> {
  constructor(props: { children: ReactNode }) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.warn('UnreadMessageBadge error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return null;
    }
    return this.props.children;
  }
}

function UnreadBadgeContent() {
  const { conversations } = useMessage();
  const totalUnread = conversations.reduce((sum, conv) => sum + conv.unreadCount, 0);
  
  if (totalUnread === 0) return null;
  
  return (
    <Badge variant="default" className="ml-auto shrink-0 h-5 min-w-[20px] px-1.5 text-xs">
      {totalUnread}
    </Badge>
  );
}

export function UnreadMessageBadge() {
  return (
    <ErrorBoundary>
      <UnreadBadgeContent />
    </ErrorBoundary>
  );
}
